/**
 * EventStatusBadge component for displaying event status (Today, Past)
 * Shared component used in both EventCard and EventDetail
 */

interface EventStatusBadgeProps {
  isToday?: boolean;
  isPast?: boolean;
  variant?: 'default' | 'overlay';
  className?: string;
}

/**
 * Status badge component
 */
export function EventStatusBadge({
  isToday = false,
  isPast = false,
  variant = 'default',
  className = '',
}: EventStatusBadgeProps) {
  if (variant === 'overlay') {
    // Overlay variant for cards (smaller, positioned absolutely)
    return (
      <div className={`flex flex-col gap-1.5 sm:gap-2 ${className}`}>
        {isToday && (
          <span className="rounded bg-accent px-1.5 py-0.5 text-[10px] font-medium text-accent-foreground shadow-md sm:px-2 sm:py-1 sm:text-xs">
            Today
          </span>
        )}
        {isPast && (
          <span className="rounded bg-muted px-1.5 py-0.5 text-[10px] font-medium text-muted-foreground shadow-md sm:px-2 sm:py-1 sm:text-xs">
            Past
          </span>
        )}
      </div>
    );
  }

  // Default variant (for detail page)
  if (!isToday && !isPast) {
    return null;
  }

  return (
    <div className={`flex gap-2 ${className}`}>
      {isToday && (
        <span className="inline-flex items-center rounded-full bg-green-100 px-3 py-1 text-sm font-medium text-green-800 dark:bg-green-900 dark:text-green-200">
          Today
        </span>
      )}
      {isPast && !isToday && (
        <span className="inline-flex items-center rounded-full bg-gray-100 px-3 py-1 text-sm font-medium text-gray-800 dark:bg-gray-800 dark:text-gray-200">
          Past Event
        </span>
      )}
    </div>
  );
}

